import _ from 'lodash';
import React from 'react';
import PublicLayout from '~Public/Layout';
import './partner-referral.less';

class Layout extends React.Component {
    public render(): JSX.Element {
        return (
            <PublicLayout>
                <div className='partner-referral'>
                    {this.props.children}
                </div>
            </PublicLayout>
        );
    }
}

export default Layout;
